goog.provide('el8.ptdata.documentReminderNotifications');
goog.provide('el8.ptdata.documentReminders');
goog.provide('el8.ptdata.documentReminder');

goog.require('el8.app.shared.dialog.setReminderDateTime');
goog.require('el8.data.practiceUsers');
goog.require('el8.data.staffGroups');
goog.require('el8.service.urls');
goog.require('el8.model.base');
goog.require('el8.service.tz');

(function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addIntProperty("patientId");
    _class.addIntProperty("forDocumentId");
    _class.addIntProperty('forUserId');
    _class.addIntProperty('forGroupId');
    _class.addDate('remindDate');
    _class.addStringProperty('remindReason');
    _class.addStringProperty('forDocumentModelClass');

    _class.prototype.asSoyMap = function(withoutOrder) {
        var mapped = this.parent.asSoyMap.call(this);
        if (!withoutOrder) {
            var order = this.getOrder();
            mapped.order = order.asSoyMap();
            mapped.forDocumentOrderType = order.getOrderType();
        }

        mapped['isPast'] = this.getRemindDate() <= el8.service.tz.today() ? true : false;
        return mapped;
    };

    _class.prototype.getAssigneeLabel = function() {
        var text = '';
        if (this.getForUserId()) {
            text = el8.data.practiceUsers.getById(this.getForUserId()).getFullName();
        } else if (this.getForGroupId()) {
            text = el8.data.staffGroups.getById(this.getForGroupId()).getName() + ' (Group)';
        }
        return text;
    };

    _class.prototype.getAssigneeId = function() {
        if (this.getForUserId()) {
            return this.getForUserId();
        } else if (this.getForGroupId()) {
            return this.getForGroupId();
        }
        return null;
    };

    //
    // Actions
    //
    // Note: these are also replicated on the AncillaryOrder class for use on order without
    // reminders. Would be good to DRY up with a mixin
    //
    _class.prototype.fulfill = function(opts) {
        var opts = opts || {};
        var doc = el8.ptdata.fetchById(this.getForDocumentId());
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('fulfillDocument', [doc.getPatientId(), doc.getId()]),
            data: JSON.stringify({
                reason: opts.reason ? opts.reason : null,
                resolving_document_id: opts.resolvingDocumentId ? opts.resolvingDocumentId : null
            }),
            success: function (data) {
                // Data is the document
                var eSet = el8.ptdata.getEntitySet(data.model_class);
                eSet.create(data);
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };

    // DRY with below
    _class.prototype.remindLater = function(opts) {
        var that = this;
        var opts = opts || {};
        var doc = el8.ptdata.fetchById(this.getForDocumentId());
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('remindLaterDocument', [doc.getPatientId(), doc.getId()]),
            data: JSON.stringify({reason: opts.reason ? opts.reason : null,
                                  date: opts.date,
                                  reminder_id: that.getId(),
                                  for_group_id: opts.reminderGroupId || null,
                                  for_user_id: opts.reminderUserId || null}),
            success: function (data) {
                // data is the reminder
                el8.ptdata.documentReminders.create(data);

                // Refresh the document this reminder is for
                if (!opts.noRefresh) { el8.ptdata.refreshDocById(doc.getId()); }
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };

    _class.prototype.getNewDate = function() {
        var reminder = this;

        el8.app.shared.dialog.setReminderDateTime.show({
            reminderAssignees: el8.data.practiceUsers.getAssignees(),
            reminder: reminder,
            defaultDateTime: el8.service.tz.todayPlusDays(7), // set a good default
            saveCallbackFn: function(obj) {
                var d = el8.service.tz.toTzDate(obj.dateTime);
                reminder.remindLater({
                    date: el8.service.tz.asServerFormatDate(d),
                    reminderUserId: obj.reminderUserId,
                    reminderGroupId: obj.reminderGroupId
                });
            }
        });
    };

    _class.prototype.getOrder = function() {
        return el8.ptdata.fetch({ patientId: this.getPatientId(), fetchId:this.getForDocumentId() });
    };

    el8.ptdata.documentReminder = function(spec) {
        return new _class(spec);
    };

    el8.ptdata.documentReminders = new el8_EntitySet({
        model: function(spec) { return new el8.ptdata.documentReminder(spec); },
        urlFn: function(id) { return el8.service.urls.get('documentReminder', [id]); }
    });
})();


el8.ptdata.documentReminderNotifications = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.makeDocument();
    _class.makeSignable();
    _class.addIntProperty('reminderId');

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);
        this.setReminderId(spec.reminder.id);
        spec.reminder.patientId = this.getPatientId();
        el8.ptdata.documentReminders.create(spec.reminder);
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        var reminder = el8.ptdata.documentReminders.getById(this.getReminderId());
        mapped.reminder = reminder.asSoyMap();
        return mapped;
    };

    // Proxy actions through to the associated reminder. "Fulfill" really means
    // set the resolution state on this document to fulfilled i.e. it's a property
    // of the document associated with the reminder not the Notification, but for convenience
    // set the state through the Notification
    _class.prototype.fulfill = function(opts) {
        var reminder = el8.ptdata.documentReminders.getById(this.getReminderId());
        if (opts.successCb) {
            var _successCb = opts.successCb;
            opts.successCb = function() {
                // Refresh self to update signed off state
                if (!opts.noRefresh) { el8.ptdata.documentReminderNotifications.refreshById(that.getId()); }
                _successCb();
            };
        }
        reminder.fulfill(opts);
    };

    _class.prototype.cancel = function(opts) {
        var that = this;
        var reminder = el8.ptdata.documentReminders.getById(this.getReminderId());

        if (opts.successCb) {
            var _successCb = opts.successCb;
            opts.successCb = function() {
                // Refresh self to update signed off state
                if (!opts.noRefresh) { el8.ptdata.documentReminderNotifications.refreshById(that.getId()); }
                _successCb();
            };
        }

        reminder.getOrder().cancel(opts);
    };

    _class.prototype.remindLater = function(opts) {
        var that = this;
        var opts = opts || {};
        var reminder = el8.ptdata.documentReminders.getById(this.getReminderId());
        var patientId = opts.patientId ? opts.patientId : null;

        if (opts.successCb) {
            var _successCb = opts.successCb;
            opts.successCb = function() {
                // Refresh self to update signed off state
                if (!opts.noRefresh) { el8.ptdata.documentReminderNotifications.refreshById(that.getId()); }
                _successCb();
            };
        }

        el8.app.shared.dialog.setReminderDateTime.show({
            reminder: reminder,
            reminderAssignees: el8.data.practiceUsers.getAssignees(patientId),
            defaultDateTime: el8.service.tz.todayPlusDays(7),
            saveCallbackFn: function(obj) {
                var d = el8.service.tz.toTzDate(obj.dateTime);
                reminder.remindLater(
                    // pass down success callback
                    _.extend(opts, {
                        date: el8.service.tz.asServerFormatDate(d),
                        reminderGroupId: obj.reminderGroupId,
                        reminderUserId: obj.reminderUserId
                    })
                );
            }
        });
    };

    // For use cases like office message bullet links
    _class.prototype.getDocumentId = function() {
        var reminder = el8.ptdata.documentReminders.getById(this.getReminderId());
        return reminder.getForDocumentId();
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) { return el8.service.urls.get('documentReminderNotifications', [id]); },
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

    return that;
})();